<template>
  <div class="user-manage">
    <div class="top">
      <div class="left">设备列表</div>
      <el-button type="primary" @click="setUser(false)">新增设备</el-button>
    </div>
    <div class="table-box">
      <el-table :data="tableData" style="width: 100%;overflow:auto;">
        <el-table-column align="center" type="index" label="序号">
        </el-table-column>
        <el-table-column prop="equipmentCode" label="设备"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="edit" label="操作" width="120">
          <template slot-scope="scope">
            <div class="btn-out-box">
              <div class="btn-box color2" title="删除" @click="deleteUser(scope.row)">
                <i class="iconfont icon-close"></i>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="新增/编辑设备" :visible.sync="dialogFormVisible">
      <!-- {{pname}} -->
      <el-form :label-position="'right'" label-width="120px">
        <el-form-item label="项目名称：">
          <el-input v-model="pname" readonly></el-input>
        </el-form-item>
        <el-form-item label="设备：">
          <el-select class="sb-select" v-model="equipmentCode" @change="changeEquipment" placeholder="切换设备">
            <el-option v-for="item in options" :key="item.equipmentCode" :label="item.equipmentCode" :value="item.equipmentCode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserHandle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import { Message } from "element-ui";
import tool from "../../utils/tool";
export default {
  data() {
    return {
      id: "",
      isAdd: true,
      tableData: [],
      dialogFormVisible: false,
      currentPage: 1,
      size: 10,
      total: 0,
      equipmentCode: "",
      options: [],
    };
  },
  props: {
    pname: {
      type: String,
      default: "",
    },
    pid: {
      type: String,
      default: "",
    },
  },
  created() {
    this.searchUsersByProject();
    this.searchProjectEquipmentsByType();
  },
  methods: {
    // paginationHandle(index) {
    //   this.currentPage = index;
    //   this.searchUsersByProject();
    // },
    // handleSizeChange(e) {
    //   this.currentPage = 1;
    //   this.size = e;
    //   this.searchUsersByProject();
    // },
    changeEquipment(v) {
      console.log(v);
      this.equipmentCode = v;
    },
    searchUsersByProject() {
      this.$http
        .post(
          "bma-distribution-service/include/searchProjectEquipmentsByProject",
          {
            projectId: this.pid,
          }
        )
        .then((res) => {
          console.log("res: ", res);

          this.tableData = res.data;
        });
    },
    searchProjectEquipmentsByType() {
      this.$http
        .post(
          "bma-distribution-service/include/searchProjectEquipmentsByType",
          {
            projectId: this.pid,
          }
        )
        .then((res) => {
          console.log("res: ", res);
          this.options = res.data;
        });
    },
    setUser(e) {
      this.equipmentCode = "";
      this.dialogFormVisible = true;
    },
    addUserHandle() {
      if (!this.equipmentCode) {
        Message.warning("请选择设备");
      } else {
        this.addNoManagerUsers();
      }
    },
    addNoManagerUsers() {
      this.$http
        .post("bma-distribution-service/include/addIncludeProjectEquipment", {
          projectId: this.pid,
          equipmentCode: this.equipmentCode,
        })
        .then((res) => {
          console.log("xinzeng: ", res);
          if (res.code == 200) {
            Message.success("新增成功");
            this.searchUsersByProject();
          }
        });
      this.dialogFormVisible = false;
    },
    deleteUser(e) {
      this.$confirm("确认删除此设备")
        .then((_) => {
          this.deleteUserHandle(e);
        })
        .catch((_) => {});
    },
    deleteUserHandle(e) {
      this.$http
        .post(
          "bma-distribution-service/include/deleteIncludeProjectEquipment",
          {
            includeId: e.id,
          }
          // {
          //   headers: {
          //     userId: e.id,
          //   },
          // }
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.currentPage = 1;
            this.searchUsersByProject();
          }
        });
    },
    setShebei(e) {
      if (!e.isOpen) return;
      this.drawer = true;
    },
  },
};
</script>

<style lang="less" scoped>
.sb-select {
  // .el-select {
  width: 100%; // }
}
.user-manage {
  background: #fff;
  padding: 20px;
  border-radius: 7px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 28px;
    .left {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .table-box {
    text-align: center;
    .el-table {
      background: rgba(0, 0, 0, 0);
      /deep/th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      /deep/th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      /deep/tr {
        td {
          font-size: 14px;
          color: #152139;
          text-align: center;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.color1.active {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
        &.color2.active {
          background: rgba(255, 41, 41, 0.1);
          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }
        &.color3.active {
          background: rgba(253, 151, 101, 0.1);
          .iconfont {
            color: rgba(253, 151, 101, 1);
          }
        }
      }
    }
  }
  /deep/.el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
  }
}
</style>